import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import '@babel/polyfill'
import 'mutationobserver-shim'
import './plugins/material-vue'
import router from './router/router'
import store from './store/store'
import './registerServiceWorker'
import axios from 'axios'
import VueAxios from 'vue-axios'
import CKEditor from '@ckeditor/ckeditor5-vue'
import Nl2br from 'vue-nl2br'
import DatePicker from 'vue2-datepicker'
// import VueSession from 'vue-session'
import ImageUploader from 'vue-image-upload-resize'
import VueI18n from 'vue-i18n'
import Print from 'vue-print-nb'

import uuid from '@estudioliver/vue-uuid-v4'

import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters)

//# import to main.js
// import Buefy from 'buefy'
// import 'buefy/dist/buefy.css'

// Vue.use(Buefy)

Vue.use(uuid)

// require('./scss/main.scss')
import '@/scss/main.scss';

// Vue.use(VueSession)
Vue.use(Print)
Vue.use(VueI18n)
Vue.use(ImageUploader)
Vue.use(DatePicker)
Vue.use(CKEditor)
Vue.component('nl2br', Nl2br)
Vue.use(VueAxios, axios)
// Vue.use(BootstrapVue)

if (process.env.NODE_ENV === 'development') {
	Vue.config.devtools = true
}

Vue.config.productionTip = false
Vue.config.performance = false

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app')

//here comes the loader
